export default __webpack_public_path__ + "static/blog6-122af48a585694f6ed51038c165449ba.png";